import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Wrapper = styled(Flex).attrs({
  column: true,
  fillSpace: true,
})`
  overflow: hidden;
`;

export const Header = styled(Flex).attrs({
  flex: '0 0 auto',
  spacing: 10,
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  flex-direction: column;
  min-height: 50px;
  padding: 0 15px;
  margin-left: 0;
  border-bottom: 1px solid rgba(40,45,48,0.1);
  z-index: 1;

  ${props => props.sticky && `
    box-shadow: 0px 5px 10px -8px #8f8f8f;
  `};
`;

export const Body = styled(Flex).attrs({
  fillSpace: true,
})`
  overflow: hidden;
  overflow-y: auto;
`;
